export default class ElementRandomiser {
    randomise (elements) {
        const rndGroups = {};
        const randomizationMap = [];

        elements.forEach(element => {
            if (!element.randomizationGroupID) {
                randomizationMap.push({ "null": [element] });
            } else {
                let rndGroup = rndGroups[element.randomizationGroupID];
                if (!rndGroup) {
                    rndGroup = rndGroups[element.randomizationGroupID] = {};
                }

                let teGroup = rndGroup[element.testElementGroupID];
                if (!teGroup) {
                    teGroup = rndGroup[element.testElementGroupID] = [];
                }

                teGroup.push(element);

                if (teGroup.length === 1) {
                    randomizationMap.push(rndGroup);
                }
            }
        });

        let randomized = [];
        randomizationMap.forEach(rndGroup => {
            const teGroup = this._randomlyPopElementsFromGroup(rndGroup);
            randomized = randomized.concat(teGroup);
        });

        return randomized;
    }

    _randomlyPopElementsFromGroup(rndGroup) {
        const keys = Object.keys(rndGroup);
        const randomKey = keys[Math.floor(Math.random() * keys.length)];
        const elements = rndGroup[randomKey];
        delete rndGroup[randomKey];
        return elements;
    }
}